var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojiNeutral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "muted") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Create-\\u2705",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "06A2---Published-(Info)",
    transform: "translate(-172.000000, -88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Toast",
    transform: "translate(16.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "muted",
    transform: "translate(156.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9996364,10.0603636 C20.9286061,10.0603636 20.0602424,10.9287273 20.0602424,11.9997576 C20.0602424,13.0707879 20.9286061,13.9391515 21.9996364,13.9391515 C23.0706667,13.9391515 23.9390303,13.0707879 23.9390303,11.9997576 C23.9390303,10.9287273 23.0706667,10.0603636 21.9996364,10.0603636 Z M9.99963636,10.0603636 C8.92860606,10.0603636 8.06024242,10.9287273 8.06024242,11.9997576 C8.06024242,13.0707879 8.92860606,13.9391515 9.99963636,13.9391515 C11.0706667,13.9391515 11.9390303,13.0707879 11.9390303,11.9997576 C11.9390303,10.9287273 11.0706667,10.0603636 9.99963636,10.0603636 Z M1.62318865,23.0160885 C0.584314564,20.8964521 -3.55271368e-15,18.5152656 -3.55271368e-15,15.9997576 C-3.55271368e-15,7.17745455 7.17745455,-8.52651283e-14 15.9997576,-8.52651283e-14 C20.1843636,-8.52651283e-14 23.9981818,1.61551515 26.8522424,4.25466667 C28.332,5.6230303 29.5539394,7.26618182 30.4350303,9.10278788 C31.4373333,11.1923636 31.9995152,13.5316364 31.9995152,15.9997576 C31.9995152,24.8220606 24.8220606,31.9995152 15.9997576,31.9995152 C11.6049697,31.9995152 7.61878788,30.2181818 4.72424242,27.3401212 L4.72424242,27.3401212 L4.38285309,26.9901072 C3.37431636,25.9245552 2.51087273,24.7206061 1.82327273,23.4104242 L1.82327273,23.4104242 Z",
    id: "Combined-Shape",
    fill: "#FFDF59"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#17243D",
    x: 12,
    y: 21,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#17243D",
    cx: 9.99963636,
    cy: 11.9997576,
    r: 1.93939394
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#17243D",
    cx: 21.9996364,
    cy: 11.9997576,
    r: 1.93939394
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiNeutral);
export default __webpack_public_path__ + "static/media/emoji-neutral.1486bda967b01047671875e1a5cec0e7.svg";
export { ForwardRef as ReactComponent };